//
const tenantReferencingServiceButton = document.querySelector('.service-button[data-service="tenant-referencing"]')


if (tenantReferencingServiceButton !== null) {

    //
    function requestServiceToken(callback) {
        const promise = fetch('/api/get-tenant-referencing-service-token', { 'method': 'POST' });
        promise.then((response) => response.json()).then((response) => {
            callback(response);
        }).catch((error) => {
            console.error(error);
        });
    }

    //
    function createFormElement(type, name, value) {
        var input = document.createElement('input');
        input.type = type;
        input.name = name;
        input.value = value;
        return input;
    }

    //toggle the information panel as needed
    tenantReferencingServiceButton.addEventListener('click', function (event) {
        if (event.target.matches('[data-action="toggle-service-information"]') == true) {
            event.target.closest('.service-button').setAttribute('data-show-service-information', ((tenantReferencingServiceButton.dataset.showServiceInformation == 'no') ? 'yes' : 'no'));
        }
    });

    //
    tenantReferencingServiceButton.querySelector('button[data-action="get-tenant-referencing-service-token"]').addEventListener('click', function (event) {

        //
        if (event.target.disabled == true) {
            return false;
        }

        //
        event.preventDefault(); event.stopPropagation();

        //
        event.target.disabled = true;

        //
        requestServiceToken(function (response) {

            let serviceTokenInput = createFormElement('hidden', 'serviceToken', response.details.serviceToken)
            let serviceTokenHashInput = createFormElement('hidden', 'serviceTokenHash', response.details.serviceTokenHash)

            const form = tenantReferencingServiceButton.querySelector('.service-button-button');

            form.appendChild(serviceTokenInput);
            form.appendChild(serviceTokenHashInput);

            form.submit();

        });

    });

}
